import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createPinia } from 'pinia'
import Antd from 'ant-design-vue'
import 'ant-design-vue/dist/reset.css'

// 引入ResizeObserver优化样式
import './assets/styles/resize-observer-fix.css'

// 忽略ResizeObserver错误（开发环境）
if (process.env.NODE_ENV === 'development') {
  const originalError = console.error
  console.error = (...args) => {
    if (
      typeof args[0] === 'string' && 
      (args[0].includes('ResizeObserver loop') || 
       args[0].includes('ResizeObserver loop completed'))
    ) {
      return
    }
    originalError(...args)
  }

  // 忽略window错误
  window.addEventListener('error', (e) => {
    if (e.message && e.message.includes('ResizeObserver')) {
      e.preventDefault()
      return false
    }
  })
}

const app = createApp(App)
const pinia = createPinia()

app.use(router)
app.use(pinia)
app.use(Antd)

app.mount('#app') 